// 1.引入vuex
import Vuex from 'vuex'
import Vue from 'vue'
//获取api列表
import Apis from '../apis/control'
import router from '../router'

Vue.use(Vuex)

// 2.创建仓库
const store=new Vuex.Store({
  // 数据
  state:{
    parkId:localStorage.getItem('parkId') || '',//临平=4，唐山=16
    username:localStorage.getItem('username') || '',
    usertype:localStorage.getItem('usertype') || '',
    refreshToken: localStorage.getItem('REFRESH_TOKEN') || '',
    token: localStorage.getItem('X_TOKEN') || '',
    backHref: process.env.backHref,//'http://localhost:8686' process.env.backHref
    type:3,//服务传3
    hostKey: localStorage.getItem('HOSTKEY') || '',
    isShowLoginView:false,//右上角-登录-显示登录弹窗-3个账号类型，false-隐藏登录弹窗，true-显示登录弹窗
    isonlyenterprise:false,//判断是否只显示企业账户的登录方式,false-显示3种登录账号类型方式，ture-仅显示企业账户登录方式
    checkInStatus:0,//1：审核中 2:未入驻 3:已入驻 4:驳回
    isShowcheckInModel:false,//企业审核状态提示弹窗 
    isSettled:localStorage.getItem('isSettled'),//是否入驻
    isMoveOut:localStorage.getItem('isMoveOut'),//是否迁出
    applyStatus:localStorage.getItem('applyStatus')||'',//审核状态 1审核中 2 通过 3 驳回
    companyId: localStorage.getItem('companyId')||'',//企业id（注意：这不是用户id，这是企业id）
    allSearch:localStorage.getItem('allSearch')||'',//全文搜索
    componyName:localStorage.getItem('componyName')||''//公司名
  },
  // 修改器
  mutations:{
    SET_USERTYPE(state,data){
      state.usertype=data;
    },
    SET_PARKID(state,data){
      state.parkId=data;
    },
    SET_USERNAME(state,data){
      state.username=data;
    },
    // 是否登录-3个账号类型
    SET_LOGIN(state,data){
      state.isShowLoginView=data;
    },
    // 是否仅显示企业登录
    SET_ONLYENTERPRISELOGIN(state,data){
      state.isonlyenterprise=data;
    },
    //用户类型判断
    SET_HOSTKEY(state, data) {
      state.hostKey = data;
    },
    //登录token
    SET_REFRESH_TOKEN(state, data) {
      state.refreshToken = data;
    },
    SET_TOKEN(state, data) {
      state.token = data;
    },
    INITE_STATE(state) {
      state.username=localStorage.getItem('username') || '';
      state.refreshToken=localStorage.getItem('REFRESH_TOKEN') || '';
      state.token=localStorage.getItem('X_TOKEN') || '';
      state.hostKey=localStorage.getItem('HOSTKEY') || '';
    },
    SET_COMPONYNAME(state,data){
      state.componyName=data;
    },
    //检查是否入驻
    SET_CHECKIN_STATE(state,data){
      if (![0].includes(data)) {
        state.isShowcheckInModel = true;
      }
      state.checkInStatus=data;
    },
    CLOSE_CHECKIN(state) {
      state.isShowcheckInModel = false;
    },
    // 全文搜索
    SET_ALLSEARCH(state,data) {
      state.allSearch = data;
    },
    SET_ISSETTLED(state,data){
      state.isSettled=data;
    }
  },
  actions:{
    async checkInState({ commit,state }, data) {
      //判断是否已经认证成功-不通过本地判断！
      // if (localStorage.getItem('checkInFlag')==1){
      //   data.type == 1 ? window.open(data.toUrl) : router.push({ path: data.toUrl,query:data.query || {} });
      //   return;
      // }

      //  满足:已入驻+未迁出+已通过(2)-才能下一步操作！机构和管理员都只是浏览，只有企业可以进行操作！
      //  isSettled: true isMoveOut: false  applyStatus:2(1审核  2通过  3驳回) 
      //  判断用户的状态-满足条件才能操作   //1：审核中 2:未入驻 3:已入驻 4:驳回
      // let isSettled=localStorage.getItem('isSettled');//是否入驻
      // let isMoveOut=localStorage.getItem('isMoveOut');//是否迁出
      // let  applyStatus=localStorage.getItem('applyStatus')||'';//审核状态 1审核中 2 通过 3 驳回

      const res=await Apis.getCompanyInfo({companyBaseId:localStorage.getItem('companyId')})
      const { code, data: userInfo } = res;
      if(code==1&&userInfo){
        const { applyStatus,isMoveOut,isSettled } = userInfo;
        localStorage.setItem('isSettled',  isSettled);
        localStorage.setItem('isMoveOut',  isMoveOut);
        localStorage.setItem('applyStatus', applyStatus);
     
        localStorage.setItem('checkInFlag', '0');
        if (isSettled!='true'&&isSettled!=true){
          commit('SET_CHECKIN_STATE',2)//未入驻
        }else{
          if (isMoveOut=='true'||isMoveOut==true){
            commit('SET_CHECKIN_STATE',3)//已入驻、已迁出
          }else{
            switch (parseInt(applyStatus)) {
              case 1:
                commit('SET_CHECKIN_STATE',1)//审核中
                break;
              case 2:
                localStorage.setItem('checkInFlag', '1');//通过
                data.type == 1 ? window.open(data.toUrl) : router.push({ path: data.toUrl, query: data.query || {} });      
                break;
              case 3:
                commit('SET_CHECKIN_STATE', 4)//驳回
                break;
              default:
                break;
            }
          }
        } 
      }

        //获取用户信息-判断企业状态-old
        // const res=await Apis.getUserInfo(state.parkId);
        // console.log(res,'用户信息')
        // const { code,data:userInfo }=res;
        // if (code == 1 && userInfo)

    }
  }
})
// 3 导出
export default store



// WEBPACK FOOTER //
// ./src/store/index.js